module.exports = __webpack_public_path__ + "static/media/deck-grid-3.174e4526.webp";